import { createFileRoute } from "@tanstack/react-router";
import { ExplorePage } from "@/modules/dashboard/presentation/pages/ExplorePage";

export const Route = createFileRoute("/_authenticated/explore")({
  component: ExplorePage,
});
